
<div style="display: flex;
justify-content: space-between;
color: #737373;
margin-bottom: 16px;padding-right: 3px;"><span>{{fileSizeobject.size}} {{fileSizeobject.type}}/50 MB</span><span>{{files.length}}/10</span></div>
<div class="file-upload-multiple">    
   <!-- star -->
   <div class="files-list" *ngFor="let file of files; let i = index">
     <div class="single-file" [title]="verifyAttachment(file.name) ? 'Saved attachment' : 'New attachment' ">
       <!-- <span class="ribbonLocal">Local</span> -->
       <div class="info" (click)="downloadAttachment(file.name)" [ngClass]="{ infoLink: verifyAttachment(file.name) }">
         <span [ngSwitch]="file.fileIcon" class="fileIcon">
           <mat-icon svgIcon="pptx" *ngSwitchCase="'pptx_Icon'"></mat-icon>
           <mat-icon svgIcon="zip" *ngSwitchCase="'zip_Icon'"></mat-icon>
           <mat-icon class="one-icons" *ngSwitchDefault>{{file?.fileIcon}}</mat-icon>
         </span>
         <span style="margin-left:20px">
           <span class="name">
             {{ file?.name }}
             <span class="localTag">Local</span>
           </span>
           <p class="size">
             {{ formatBytes(file?.size) }}
           </p>
         </span>
       </div>
       <mat-icon class="one-icons" (click)="deleteFile(i,file)" style="cursor: pointer; width: 14px;
      height: 18px;padding-bottom: 9px;">delete_outline</mat-icon>
     </div>
  </div>
  <!-- end --> 
  <div class="container" dlAppDnd (fileDropped)="onFileDroppedandSelect($event)">
    <input type="file" #fileDropRefMul id="fileDropRefMul"  (change)="onFileDroppedandSelect($event.target.files)" multiple />
    <div class="dl-svg-img"></div>  
    <span>Drag item here or<label for="fileDropRefMul">Upload</label> the file</span> 
  </div>
</div>
